function getBlob(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        callback(xhr.response);
    };
    xhr.crossOrigin = 'anonymous';
    xhr.responseType = 'blob';
    xhr.open('GET', url);
    xhr.send();
}
